import { Components } from "@thisgorilla/primate-ds";
import styled from "styled-components";
import { API_CALLS } from "../../../API/api_calls";
import { useAppSelector } from "../../../redux";
import { FlexRow } from "../Styles";
import { PopupProps } from "./Popup";

export const FollowMessageAndMore = (
  props: PopupProps.FollowMessageAndMore
) => {
  const {
    followingIds,
    followAUser_API_STATUS,
    unfollowAUser_API_STATUS,
    selectedUserId,
  } = useAppSelector((state) => state.connections);
  const { id, is_following } = props;
  //TODO: handle company type from props when company popup is implemented

  const handleFollow = () => API_CALLS.CONNECTIONS.followAUser({ id });
  const handleUnfollow = () => API_CALLS.CONNECTIONS.unfollowAUser({ id });

  const isFollowing = followingIds[id] || is_following;
  const isLoading =
    followAUser_API_STATUS === "progress" && selectedUserId === id;

  return (
    <Container $gapInPx={4}>
      <Components.Button
        kind="Primary"
        color={isFollowing ? "Neutral" : "Primary"}
        disabled={false}
        iconPosition="left"
        iconType={
          isFollowing ? undefined : isLoading ? "MoreHorizontal" : "Plus"
        }
        label={isFollowing ? "Following" : "Follow"}
        onClick={() => {
          if (followAUser_API_STATUS === "progress") return;
          if (unfollowAUser_API_STATUS === "progress") return;

          isFollowing ? handleUnfollow() : handleFollow();
        }}
        size="Small"
        width="fill"
      />
      <Components.Button
        kind="Primary"
        color="Neutral"
        size="Small"
        disabled={false}
        iconPosition="left"
        iconType="MessageCircle"
        label="Message"
        onClick={() => {}}
        width="fill"
      />
      <Components.IconButton
        kind="Secondary"
        size="Small"
        disabled={false}
        iconType="MoreHorizontal"
        onClick={() => {}}
      />
    </Container>
  );
};

const Container = styled(FlexRow)``;
